(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifDebug', swifDebug);


        /**
        * @ngdoc directive
        * @name swif.ui:swifDebug
        * @module swif.ui
        * @restrict A
        * @description display a complete object using pretty print
        * @usage
        * <div swif-debug="model"></div>  
        **/
        
    function swifDebug() {
        return {
            restrict: 'A',
            transclude: true,
            scope: {
                swifDebug: '='
            },
            template: '<h2 ng-transclude></h2><pre>{{swifDebug | json}}</pre>'
        };
    }

})();